import type { FC, ReactNode } from 'react';

import { Note } from '@components/ui/Note';

import type { SxProps } from '@mui/material';


export type AuthFormNotificationProperties = {
  isError?: boolean;
  isSuccess?: boolean;
  errorTitle?: string;
  errorMessage?: ReactNode;
  successTitle?: string;
  successMessage?: ReactNode;
  dataTest?: string;
  sx?: SxProps;
};

export const AuthFormNotification: FC<AuthFormNotificationProperties> = ({
  isError,
  isSuccess,
  errorTitle = 'Ошибка',
  errorMessage,
  successTitle = 'Успешно',
  successMessage,
  dataTest,
  sx,
}) => {
  if (!isError && !isSuccess) return;

  if (isError) {
    return (
      <Note
        dataTest={dataTest ? `${dataTest}_failure` : 'auth_note_failure'}
        variant='error'
        noteTitle={errorTitle}
        sx={sx}
      >
        {errorMessage ?? 'Неизвестная ошибка'}
      </Note>
    );
  }

  return (
    <Note
      dataTest={dataTest ? `${dataTest}_success` : 'auth_note_success'}
      variant='success'
      noteTitle={successTitle}
      sx={sx}
    >
      {successMessage}
    </Note>
  );
};
